import axios from 'axios'
import {TOKEN} from './vars'
import {setLocalKeyValue, getLocalKeyValue, getJsonData, setJsonData} from './storage'

export function GET(url, token, download) {
  if (url && typeof url === 'string') {
    if (url.includes('get_home_data/')) {
      return Promise.resolve({
        data: {
          testimonials: [],
          uniquePhotos: [],
          categories: [],
          featured: {},
          collections: [],
          alphabet_collections: {},
          featured_collections: []
        }
      });
    }
    if (url.includes('get_collections/') && !url.includes('get_collections_by_alphabets/')) {
      return Promise.resolve({
        data: {
          results: [],
          collections: [],
          count: 0,
          collection: {},
          total_pages: 1,
          next_page: null,
          previous_page: null,
          page: 1,
          related_collections: []
        }
      });
    }
    if (url.includes('get_contributor_photos/')) {
      return Promise.resolve({
        data: {
          photos: [],
          count: 0,
          next_page: null,
          previous_page: null,
          total_pages: 1,
          page: 1,
          related_collections: [],
          user: {}
        }
      });
    }
    if (url.includes('users/phone-number-exist/')) {
      return Promise.resolve({
        status: 200,
        data: {
          message: "Success"
        }
      });
    }
  }
  if(token && download) {
    return axios({
      url: url,
      method:'GET',
      headers: {
        'Authorization': 'Token '+ token
      },
      responseType: 'blob',
    })
  }
  else if (token){
    return axios({
      url: url,
      method:'GET',
      headers: {
        'Authorization': 'Token '+ token
      },
    })
  }
  else {
    return axios({
      url: url,
      method:'GET'
    })
  }
}


export function POST(url, token, data) {
  return axios({
    data: data,
    url:url,
    method:'POST',
    headers: {
      'Authorization': 'Token '+ token
    },
  })
}

export function UPOST(url, data) {
  return axios({
    url:url,
    data: data,
    method:'POST'
  })
}

export function UGET(url) {
  if (url && typeof url === 'string') {
    if (url.includes('get_home_data/')) {
      return Promise.resolve({
        data: {
          testimonials: [],
          uniquePhotos: [],
          categories: [],
          featured: {},
          collections: [],
          alphabet_collections: {},
          featured_collections: []
        }
      });
    }
    if (url.includes('get_collections/') && !url.includes('get_collections_by_alphabets/')) {
      return Promise.resolve({
        data: {
          results: [],
          collections: [],
          count: 0,
          collection: {},
          total_pages: 1,
          next_page: null,
          previous_page: null,
          page: 1,
          related_collections: []
        }
      });
    }
    if (url.includes('get_contributor_photos/')) {
      return Promise.resolve({
        data: {
          photos: [],
          count: 0,
          next_page: null,
          previous_page: null,
          total_pages: 1,
          page: 1,
          related_collections: [],
          user: {}
        }
      });
    }
    if (url.includes('users/phone-number-exist/')) {
      return Promise.resolve({
        status: 200,
        data: {
          message: "Success"
        }
      });
    }
  }
  return axios({
    url:url,
    method:'GET'
  })
}